import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { CLIENT_COLUMN, SALES_CLIENT_MODULE } from "../constant/salesReceiptConstant";

export const setSalesReceiptClientPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SALES_CLIENT_MODULE,
        default_columns: CLIENT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
